export const buildAgencies = (agencies = [], companies, dealers = []) =>
    agencies.map(agency => buildAgency(agency, companies, dealers));

const buildAgency = (agency, companies, dealers = []) => {
    const projectIds = Array.isArray(agency.projects) && agency.projects.length
        ? agency.projects
        : (agency.project ? [agency.project] : []);

    const resolvedCompanies = projectIds
        .map(identifier => companies.find(company => company.crm_area.identifier === identifier))
        .filter(Boolean);

    const resolvedDealer = agency.dealer
        ? dealers.find(dealer => dealer.identifier === agency.dealer)
        : null;

    return {
        ...agency,
        companies: resolvedCompanies,
        company: resolvedCompanies[0] || {},
        dealerName: resolvedDealer?.name || '',
        description: agency.description,
        contact: {
            ...(agency.contact || {}),
            name: agency.contact?.name || "",
            last_name: agency.contact?.last_name || ""
        }
    };
};

export const buildLocationAttributes = (attr) => {

    const address_components = {};

    attr.address_components.forEach(element => {
        if (element.types.includes("street_number")) {
            address_components.street_number = element.long_name;
        } else if (element.types.includes("route")) {
            address_components.address = element.long_name;
        } else if (element.types.includes("locality")) {
            address_components.city = element.long_name;
        } else if (element.types.includes("administrative_area_level_1")) {
            address_components.state = element.long_name;
        } else if (element.types.includes("country")) {
            address_components.country = element.long_name;
        } else if (element.types.includes("postal_code")) {
            address_components.zip_code = element.long_name;
        }
    });

    return { name: attr.formatted_address, address_components }
};